import { render, staticRenderFns } from "./HeaderDeDados.vue?vue&type=template&id=7e3a8ade&scoped=true"
import script from "./HeaderDeDados.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderDeDados.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HeaderDeDados.vue?vue&type=style&index=0&id=7e3a8ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3a8ade",
  null
  
)

export default component.exports